import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { AlertService } from 'src/app/services/common/alert.service';
import { ConstantTypeKey, UserTypeEnum, productForUserTypes } from 'src/app/services/common/constant.service';
import { UtilityService } from 'src/app/services/utility.service';
import { LoginService } from '../login/login.service';
import { TermConditionPageComponent } from 'src/app/shared/widgets/term-condition-page/term-condition-page.component';
import { MatDialog } from '@angular/material/dialog';
import { IndexedDBService } from 'src/app/services/common/indexedDb.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  countryList: any[];
  stateList: any[];
  cityList: any[];

  userTypeList: any[];
  industryVerticalList: any[];
  typeOfAgencyList: any[];

  submitted = false;
  registrationForm: FormGroup;

  get f() { return this.registrationForm.controls; }

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private loginService: LoginService,
    private utilityService: UtilityService,
    private alertService: AlertService,
    private indexedDbService: IndexedDBService,
    private formBuilder: FormBuilder) { }

  async ngOnInit() {
    this.buildForm();
    await this.getConstantList();
    //this.getCountryList();
    this.countryList = await this.indexedDbService.getCountires();
    this.disableControl();
    this.onChangeUserType();
  }

  buildForm(): void {
    this.registrationForm = this.formBuilder.group({
      userType: [UserTypeEnum.RETAILER, [Validators.required]],
      industryVertical: [''],
      typeOfAgency: [''],
      firstName: ['', [Validators.required]],
      lastName: [''],
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
      company: ['', [Validators.required]],
      address: ['', [Validators.required]],
      country: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      countryCode: ['', [Validators.required]],
      telephone: ['', [Validators.required, Validators.minLength(10)]],
      termsCondition: [true]
    }, {
      validators: this.passwordMatch.bind(this)
    }
    );
  }

  passwordMatch(formGroup: FormGroup) {
    const password = formGroup.get('password');
    const confirmPassword = formGroup.get('confirmPassword');

    const matchingControl = formGroup.controls['confirmPassword'];

    // return if another validator has already found an error on the matchingControl
    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      return;
    }

    // set error on matchingControl if validation fails
    if (password?.value === confirmPassword?.value) {
      matchingControl.setErrors(null);
    }
    else {
      matchingControl.setErrors({ mustMatch: true });
    }
  }

  disableControl() {
    this.f.countryCode.disable();
  }

  async getConstantList() {
    await this.utilityService.getConstantList(ConstantTypeKey.IndustryVertical).toPromise().then((response: any) => {
      if (response.success) {
        this.industryVerticalList = response.data;
      }
    })

    await this.utilityService.getConstantList(ConstantTypeKey.UserType).toPromise().then((response: any) => {
      if (response.success) {
        this.userTypeList = response.data.filter((x: { code: string; }) => x.code != UserTypeEnum.ADMIN);
      }
    })

    await this.utilityService.getConstantList(ConstantTypeKey.AgencyType).toPromise().then((response: any) => {
      if (response.success) {
        this.typeOfAgencyList = response.data;
      }
    })
  }

  // public getCountryList() {
  //   this.utilityService.getCountryList().subscribe((res: any) => {
  //     if (res.success) {
  //       this.countryList = res.data;
  //     }
  //   })
  // }

  public getStateList(countryId: any) {
    this.utilityService.getStatesList(countryId).subscribe((res: any) => {
      if (res.success) {
        this.stateList = res.data;
      } else {
        this.stateList = [];
      }
    })
  }

  public getCityList(stateId: any) {
    this.utilityService.getCityList(stateId).subscribe((res: any) => {
      if (res.success) {
        this.cityList = res.data;
      } else {
        this.cityList = []
      }
    })
  }

  onChangeUserType() {
    if (this.f.userType.value == "AGEN") {
      this.registrationForm.controls["typeOfAgency"].setValidators(Validators.required);
      this.registrationForm.controls["industryVertical"].clearValidators();
      this.f.typeOfAgency.enable();
      this.f.industryVertical.disable();
      this.f.industryVertical.setValue('');
      this.f.typeOfAgency.setValue('DIST');
    }
    else {
      this.registrationForm.controls["typeOfAgency"].clearValidators();
      this.registrationForm.controls["industryVertical"].setValidators(Validators.required);
      this.f.typeOfAgency.disable();
      this.f.industryVertical.enable();
      this.f.typeOfAgency.setValue('');
    }
    this.registrationForm.controls['industryVertical'].updateValueAndValidity();
    this.registrationForm.controls['typeOfAgency'].updateValueAndValidity();
  }

  onChangeCountry(event: any) {
    if (event.value) {
      let country = this.countryList.find(x => x.id == event.value)
      if (country) {
        this.f.countryCode.setValue(country.code);
        this.stateList = [];
        this.cityList = [];
        this.f.state.setValue('');
        this.f.city.setValue('');
      }
      else {
        this.f.countryCode.setValue('');
        this.stateList = [];
        this.cityList = [];
        this.f.state.setValue('');
        this.f.city.setValue('');
      }
      this.getStateList(event.value);
    }
    else {
      this.f.countryCode.setValue('');
      this.f.state.setValue('');
      this.f.city.setValue('');
      this.stateList = [];
      this.cityList = [];
    }
  }

  onChangeState(event: any) {
    this.f.city.setValue('');
    if (event.value) {
      this.getCityList(event.value);
    } else {
      this.cityList = [];
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.registrationForm.invalid)
      return;

    var model = Object.assign({});

    model.userType = [this.f.userType.value];
    model.registration_source = productForUserTypes(model.userType);
    model.industryVertical = this.f.industryVertical.value;
    model.typeOfAgency = this.f.typeOfAgency.value;
    model.firstName = this.f.firstName.value;
    model.lastName = this.f.lastName.value;
    model.password = this.f.password.value;
    model.company = this.f.company.value;
    model.address = this.f.address.value;
    model.countryId = this.f.country.value;
    model.stateId = this.f.state.value;
    model.cityId = this.f.city.value;
    model.email = this.f.email.value;
    // model.countryCode = this.f.countryCode.value;
    model.telephone = this.f.telephone.value;
    model.termsCondition = this.f.termsCondition.value;

    this.loginService.register(model).pipe(first()).subscribe({
      next: (response: any) => {
        if (response.success) {
          //this.alertService.showSuccess("Sign Up succesfully");
          this.router.navigate(['login']);
        }
      }
    });
  }

  onClickBack() {
    this.router.navigate(['login']);
  }

  onClickTermCondition() {
    let dialogRef = this.dialog.open(TermConditionPageComponent, {
      disableClose: true,
      width: '50%',
    });
    dialogRef.afterClosed().subscribe(result => {
      this.f.termsCondition.setValue(true);
    });
  }
}